import React from 'react';
import { Link, useParams } from 'react-router-dom';
import { ArrowUpRight, Check, Hourglass, Loader2, LockKeyhole } from 'lucide-react';
import { DashboardLayout } from '../DashboardLayout';
import { usePlus360 } from '../../hooks/usePlus360';
import { Plus360Cta, Plus360Mark } from './Plus360';

// Anciennes clés de module → module 360+ affiché dans le teaser
export const PLUS_KEY_OF = { secretary_ai: 'hub_connexion', pro_gestion: 'hub_connexion', margin_autopilot: null, livraison_360: null, basecamp: 'basecamp', recrutement: 'recrutement', social_360: 'social_360', relation_client: 'relation_client', prime_360: 'prime_360', hub_connexion: 'hub_connexion', studio_design: 'studio_design' };

/** Page « Module verrouillé » : badge 360+, module demandé, les 7 modules inclus, un seul CTA. */
const LockedPage = ({ moduleKey, title }) => {
  const { plus } = usePlus360();
  const { tenantSlug } = useParams();
  const key = PLUS_KEY_OF[moduleKey] ?? moduleKey;
  const mod = plus?.modules?.find((m) => m.key === key);
  const label = mod?.label || title;
  return <div className="plus-locked" data-testid={`plus360-boundary-teaser-${moduleKey}`}>
    <section className="plus-locked-hero hp-card">
      <Plus360Mark size={40} testId={`plus360-boundary-mark-${moduleKey}`} />
      <div className="plus-locked-copy">
        <p className="plus-locked-kicker"><LockKeyhole size={12} /> Module verrouillé</p>
        <h1 data-testid={`plus360-boundary-title-${moduleKey}`}>{label}<span className="kit-dot">.</span></h1>
        <p className="plus-locked-line" data-testid={`plus360-boundary-teaser-${moduleKey}-line`}>{mod?.hook || plus?.tagline || 'Tous les modules experts, un seul abonnement.'}</p>
        <div className="plus-locked-actions">
          <Link to={`/${tenantSlug}/plus-360`} className="fh-btn" data-testid={`plus360-boundary-teaser-${moduleKey}-btn`}>Débloquer avec 360+<ArrowUpRight size={16} /></Link>
          <span className="kit-tag is-sun">349 € HT / mois</span>
        </div>
      </div>
    </section>
    <h2 className="plus-locked-sub">Inclus dans 360+</h2>
    <ul className="plus-locked-list" data-testid={`plus360-boundary-modules-${moduleKey}`}>
      {(plus?.modules || []).map((m) => <li key={m.key} className={`hp-card ${m.key === key ? 'is-current' : ''}`} data-testid={`plus360-boundary-module-${m.key}`}>
        <span className="plus-locked-dot">{m.coming_soon ? <Hourglass size={12} /> : <Check size={12} />}</span>
        <span className="plus-locked-name">{m.label}</span>
        <span className="plus-locked-hook">{m.coming_soon ? 'Bientôt' : m.hook}</span>
      </li>)}
    </ul>
    <div className="plus-locked-foot"><Plus360Cta testId={`plus360-boundary-cta-${moduleKey}`} /></div>
  </div>;
};

/** Garde de route : sans 360+, la page laisse place à l'écran « Module verrouillé » (jamais une page qui semble accessible). */
export const Plus360Boundary = ({ moduleKey, title, children }) => {
  const { plus, loading, error, locked } = usePlus360();
  if (plus?.enabled) return children;
  return <DashboardLayout title={title} showBack hideExperts>
    <section className="app-da is-inline plus-locked-page" data-testid={`plus360-boundary-${moduleKey}`}>
      {loading && !plus ? <p className="plus-note flex items-center gap-2" role="status" data-testid={`plus360-boundary-loading-${moduleKey}`}><Loader2 size={17} className="animate-spin" />Vérification de votre accès…</p>
        : error ? <p role="alert" className="plus-note" data-testid={`plus360-boundary-error-${moduleKey}`}>Impossible de vérifier votre accès. Réessayez dans un instant.</p>
        : locked ? <LockedPage moduleKey={moduleKey} title={title} /> : null}
    </section>
  </DashboardLayout>;
};
